<div
  class="app-types"
>
  <div>
    To create a new app, choose from the available types below.
  </div>

  <div
    class="app-type"
  >
    <div
      class="title"
    >
      <h2>
        Mosaic&trade; by Motion
      </h2>

      <button
        class="green"
        (click)="createMosaic()"
      >
        Create App
      </button>
    </div>

    <div
      class="summary"
    >
      <div
        class="graphic"
      >
        @for (icon of sampleTileIcons; track icon) {
          <div
            [ngClass]="['icon-tile', icon.color]"
          >
            <span>
              <i class="fa-regular fa-{{icon.icon}}"></i>
            </span>
          </div>
        }
      </div>
      <div
        class="description"
      >
        <h3>Beautiful Dashboards</h3>
        View, configure, and control your building from anywhere by placing and
        arranging Motion tiles into the perfect dashboard with <strong>Mosaic&trade; by Motion</strong>.
        <br><br>
        Easily create and rearrange groups of tiles, view historical data, tend
        to alarms, and share your Mosaic dashboard with other Motion users.
        <br><br>
        Mosaic apps are free to create, use, and share.
      </div>
    </div>
  </div>
</div>
